import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import workSpaceCss from "../../css/workSpaceOverView.module.css";
import FSSideMenu from "../../components/standalonefs/FSSideMenu";
import FSTopBar from "../../components/standalonefs/FSTopBar";
import CashflowWorkings from "../libraries/CashflowWorkings";
import SidePanel from "../libraries/SidePanel.jsx";
import AdjustmentLog from "./AdjustmentLog";
import AddNewAdjustment from "./AddNewAdjustment";
import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getPopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
  replaceNotesTableApiHandler,
  addNotesSubgroupApiHandler,
  replaceSocieApiHandler,
  addCashflowRowApiHandler,
  rearrangeCashflowRowApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import QuillReactEditor from "../../components/QuillReactEditor";
import FSTable from "./FSTable";
import ViewRPTTransactions from "./ViewRPTTransactions";
import { Spinner } from "react-bootstrap";
import { ReactComponent as CirclePlus } from "../../assets/icons/circlePlus.svg";
import { ReactComponent as AddEditor } from "../../assets/icons/addEditor.svg";
import { ReactComponent as AddTable } from "../../assets/icons/addTable.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


import TemplateTableGenerator from "../libraries/TemplateTableGenerator";
import MenuIcon from "../../assets/icons/Menu.png";


const StandaloneFinancialStatement = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showAddAdjustment, setShowAddAdjustment] = useState(false);
  const [activeCat, setActiveCat] = useState(
    localStorage.getItem("activeCat") || "BS"
  );
  const [isNotes, setIsNotes] = useState(false);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const [showCashflowWorkings, setShowCashflowWorkings] = useState(
    localStorage.getItem("showCashflowWorkings") === "true"
  );
  const [fsNotesResponseData, setFsNotesResponseData] = useState(null);
  const [redirectSearch, setRedirectSearch] = useState(null);
  const [targetSubGroupId, setTargetSubGroupId] = useState(null);

  const [bottomBlocks, setBottomBlocks] = useState([]);
  const [isAddingTable, setIsAddingTable] = useState(false);
  const [forceOpenTableId, setForceOpenTableId] = useState(null);
  const [isSavingTable, setIsSavingTable] = useState(true);
  const bottomBlocksRef = useRef([]);
  const standaloneTableSaveTimeoutRef = useRef({});
  const skipStandaloneTableSaveOnceRef = useRef({});
  
  const genId = () => Math.random().toString(36).slice(2);
  const hiddenStandaloneTableKeys = ["isSubRow", "isNewRow", "isNew"];

  const getVisibleStandaloneTableRows = (tableRows = []) =>
    (Array.isArray(tableRows) ? tableRows : []).map((row) => {
      const nextRow = { ...(row || {}) };
      hiddenStandaloneTableKeys.forEach((key) => {
        delete nextRow[key];
      });
      return nextRow;
    });

  const hasVisibleStandaloneTableValues = (tableRows = []) =>
    getVisibleStandaloneTableRows(tableRows).some((row) =>
      Object.values(row || {}).some(
        (value) =>
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ""
      )
    );

  useEffect(() => {
    bottomBlocksRef.current = bottomBlocks;
  }, [bottomBlocks]);

  const handleAddParagraph = async () => {
  try {
    const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
    let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
    
    if (!activeGroupId && catToUse === "cashflowWorkings") {
      const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
      if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
        activeGroupId = tempRes.data.data[0]._id;
      }
    }

    if (!activeGroupId) {
      swal("Error", "No group ID found. Please try refreshing the page.", "error");
      return;
    }

    const params = {
      projectID: project_id,
      category: catToUse,
      groupID: activeGroupId,
    };

    const payload = {
      dataType: "text",
      textRaw: "<p></p>",
      textPlain: ""
    };

    const response = await addNotesSubgroupApiHandler(
      params,
      payload
    );

    if (response?.data?.success) {
      await getPopulateFSNotes(catToUse);
    }
  } catch (err) {
  console.log("STATUS", err.response?.status);
  console.log("DATA", err.response?.data);
  console.log("FULL ERROR", err);

  swal("Error", "Unable to create editor", "error");
}
};

  const handleTableBlockChange = async (blockId, next) => {
    try {
      if (standaloneTableSaveTimeoutRef.current[blockId]) {
        clearTimeout(standaloneTableSaveTimeoutRef.current[blockId]);
      }
      skipStandaloneTableSaveOnceRef.current[blockId] = true;
      
      setIsSavingTable(true);
      const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
      let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;
      
      if (!activeGroupId && catToUse === "cashflowWorkings") {
        const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
        if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
          activeGroupId = tempRes.data.data[0]._id;
        }
      }

      if (!activeGroupId) {
        swal("Error", "No group ID found. Please try refreshing the page.", "error");
        setIsSavingTable(false);
        return;
      }

      const params = {
        projectID: project_id,
        category: catToUse,
        groupID: activeGroupId,
      };
      
      // Format table columns with proper structure
      const tableColumnData = (next.tableColumn || []).map((col) => ({
        name: col.name || ""
      }));
      
      const finalTableColumn = tableColumnData.length > 0
        ? tableColumnData
        : [{ name: "Particulars" }, { name: "Current Year" }, { name: "Previous Year" }];

      const payload = {
        dataType: "table",
        tableTitle: next.tableTitle || "New Table",
        tableType: "default",
        tableColumn: finalTableColumn,
        // tableRow: next.tableRow,
        // hasCellData: next.hasCellData,
      };
      
      const response = await addNotesSubgroupApiHandler(params, payload);
      if (response?.data?.success) {
        const newSubgroup = response.data.data;
        
        const tableDataToSave = next.tableData || next.table || [];
        
        // Map frontend column names to strict backend schema fields
        const fieldMapping = {};
        finalTableColumn.forEach((col, idx) => {
          let mappedField = `column_${idx}`;
          if (col.name?.toLowerCase() === "particulars") mappedField = "particular";
          if (col.name?.toLowerCase() === "current year") mappedField = "currentYear";
          if (col.name?.toLowerCase() === "previous year") mappedField = "previousYear";
          fieldMapping[col.name] = mappedField;
        });

        const cleanRows = tableDataToSave.map(({ _id, id, isNewRow, isSubRow, lineType, rowID, cashflowID, subNoteID, ...rest }) => {
          const newRow = { lineType: lineType || "line item" };
          Object.entries(rest).forEach(([key, val]) => {
            const mappedKey = fieldMapping[key] || key;
            newRow[mappedKey] = val;
          });
          return newRow;
        });
        
        if (cleanRows.length > 0) {
          const updateParams = { ...params, subgroupID: newSubgroup._id || newSubgroup.id };
          const updatePayload = { table: cleanRows };
          const useReplaceApi = ["general notes", "disclosure", "cashflowWorkings"].includes(catToUse);
          if (useReplaceApi) {
            await replaceNotesTableApiHandler(updateParams, updatePayload);
          } else {
            await updatePopulateFSApiHandler(updateParams, updatePayload);
          }
        }
        await getPopulateFSNotes(catToUse);
        setBottomBlocks((prev) => prev.filter((b) => b.id !== blockId));
        swal({
          title: "Success",
          text: "Table added successfully",
          icon: "success",
          button: "OK",
          timer: 1500
        });
      } else {
        swal("Error", response?.data?.message || "Failed to save table", "error");
      }
    } catch (err) {
      console.error("Error adding table:", err?.response || err);
      const errorMsg = err?.response?.data?.message || "Failed to add table. Please try again.";
      swal("Error", errorMsg, "error");
    } finally {
      setIsSavingTable(false);
    }
  };

  const handleAddTableWithoutModal = () => {
    const newTableId = genId();
    setBottomBlocks((prev) => [
      {
        id: newTableId,
        type: "table",
        tableTitle: "New Table",
        tableColumn: [],
        tableRow: [],
        table: [],
        tableData: [],
        isTemp: true,
        isSaved: false,
        forceOpen: true,
      },
      ...prev,
    ]);
  };

  const getStandaloneTableRowsForSave = (tableRows = []) =>
    (Array.isArray(tableRows) ? tableRows : []).map((row) => {
      const nextRow = { ...(row || {}) };
      delete nextRow.isSubRow;
      delete nextRow.isNewRow;
      delete nextRow.isNew;
      return nextRow;
    });

  const sanitizeStandaloneTableRows = (tableRows = []) =>
    getStandaloneTableRowsForSave(tableRows).filter((row) =>
      Object.entries(row || {}).some(([key, value]) => {
        if (["_id", "id", "lineType", "rowID", "cashflowID", "subNoteID"].includes(key)) {
          return false;
        }
        return (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ""
        );
      })
    );

  const hasStandaloneTableValues = (tableRows = []) =>
    sanitizeStandaloneTableRows(tableRows).some((row) =>
      Object.entries(row || {}).some(([key, value]) => {
        if (["_id", "id", "lineType", "rowID", "cashflowID", "subNoteID"].includes(key)) {
          return false;
        }
        return (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ""
        );
      })
    );

  const queueStandaloneTableSave = (blockId) => {
    const existingTimeout = standaloneTableSaveTimeoutRef.current[blockId];
    if (existingTimeout) {
      clearTimeout(existingTimeout);
    }

    standaloneTableSaveTimeoutRef.current[blockId] = setTimeout(() => {
      const latestTable = bottomBlocksRef.current.find(
        (block) => block.id === blockId
      );

      if (!latestTable || latestTable.isCreating) {
        return;
      }

      if (skipStandaloneTableSaveOnceRef.current[blockId]) {
        skipStandaloneTableSaveOnceRef.current[blockId] = false;
        return;
      }

      const sanitizedRows = sanitizeStandaloneTableRows(
        latestTable.tableData || latestTable.table || []
      );
      const currentSerialized = JSON.stringify(sanitizedRows);
      const lastSavedSerialized = JSON.stringify(
        latestTable.lastSavedTableData || []
      );

      if (currentSerialized === lastSavedSerialized) {
        return;
      }

      const hasEnteredValues = sanitizedRows.length > 0;

      if (hasEnteredValues) {
        saveTableToApi(blockId, latestTable);
      }
    }, 150);
  };

  const createStandaloneTableStructure = async (blockId, tableData) => {
    const catToUse =
      activeCat === "cashflow" && showCashflowWorkings
        ? "cashflowWorkings"
        : activeCat;
    let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;

    if (!activeGroupId && catToUse === "cashflowWorkings") {
      const tempRes = await getPopulateFSDetailsApiHandler({
        projectID: project_id,
        category: "cashflowWorkings",
      });
      if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
        activeGroupId = tempRes.data.data[0]._id;
      }
    }

    if (!activeGroupId) {
      console.error("No group ID found");
      return null;
    }

    const params = {
      projectID: project_id,
      category: catToUse,
      groupID: activeGroupId,
    };

    const payload = {
      dataType: "table",
      tableTitle: tableData.tableTitle || "New Table",
      tableType: "default",
      tableColumn: tableData.tableColumn || [],
    };

    setBottomBlocks((prev) =>
      prev.map((b) => (b.id === blockId ? { ...b, isCreating: true } : b))
    );

    try {
      const response = await addNotesSubgroupApiHandler(params, payload);
      if (!response?.data?.success) {
        return null;
      }

      const newSubgroup = response.data.data;
      const subgroupID = newSubgroup._id || newSubgroup.id;

      setBottomBlocks((prev) =>
        prev.map((b) =>
          b.id === blockId
            ? {
                ...b,
                subgroupID,
                isTemp: false,
                isCreating: false,
              }
            : b
        )
      );

      await getPopulateFSNotes(catToUse);
      return subgroupID;
    } catch (err) {
      console.error("Error creating standalone table structure:", err);
      setBottomBlocks((prev) =>
        prev.map((b) => (b.id === blockId ? { ...b, isCreating: false } : b))
      );
      return null;
    }
  };

  const isStandaloneBlankRow = (row = {}) =>
    !Object.entries(row || {}).some(([key, value]) => {
      if (["_id", "id", "lineType", "rowID", "cashflowID", "subNoteID"].includes(key)) {
        return false;
      }
      return (
        value !== null &&
        value !== undefined &&
        String(value).trim() !== ""
      );
    });

  const saveTableToApi = async (blockId, tableData) => {
    try {
      setIsSavingTable(true);
      const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
      let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;

      if (!activeGroupId && catToUse === "cashflowWorkings") {
        const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
        if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
          activeGroupId = tempRes.data.data[0]._id;
        }
      }

      if (!activeGroupId) {
        console.error("No group ID found");
        return false;
      }

      const params = {
        projectID: project_id,
        category: catToUse,
        groupID: activeGroupId,
      };

      const payload = {
        dataType: "table",
        tableTitle: tableData.tableTitle || "New Table",
        tableType: "default",
        tableColumn: tableData.tableColumn || [],
      };

      let subgroupID = tableData.subgroupID;

      if (!subgroupID) {
        subgroupID = await createStandaloneTableStructure(blockId, tableData);
        if (!subgroupID) {
          return false;
        }
      }

      const rowsToSave = sanitizeStandaloneTableRows(
        tableData.tableData || tableData.table || []
      );

      if (rowsToSave.length > 0) {
        const updateParams = { ...params, subgroupID };
        const updatePayload = { table: rowsToSave };
        const useReplaceApi = ["general notes", "disclosure", "cashflowWorkings"].includes(catToUse);
        if (useReplaceApi) {
          await replaceNotesTableApiHandler(updateParams, updatePayload);
        } else {
          await updatePopulateFSApiHandler(updateParams, updatePayload);
        }
      }

      setBottomBlocks((prev) =>
        prev.map((b) =>
          b.id === blockId
            ? {
                ...b,
                isTemp: false,
                isSaved: true,
                isCreating: false,
                lastSavedTableData: rowsToSave,
              }
            : b
        )
      );
        return true;
    } catch (err) {
      console.error("Error saving table:", err);
      return false;
    } finally {
      setIsSavingTable(false);
    }
  };

  const removeItem = (id) => {
    setBottomBlocks((prev) => prev.filter((b) => b.id !== id));
  };

  const renderBottomBlocks = () => (
    <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
      <DragDropContext onDragEnd={onDragEndItems}>
        <Droppable droppableId="standalone-bottom-items">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ display: "grid", gap: 20 }}
            >
              {bottomBlocks.map((it, idx) => (
                <Draggable key={it.id} draggableId={it.id} index={idx}>
                  {(dragProvided) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      style={{
                        ...dragProvided.draggableProps.style,
                        width: "100%",
                      }}
                    >
                      {it.type === "text" ? (
                        <QuillReactEditor
                          value={it.text?.[0]?.content ?? " "}
                          onChange={(content) => {
                            updateEditorContent(it.id, content);
                          }}
                          dragHandleProps={dragProvided.dragHandleProps}
                          rightControl={null}
                        />
                      ) : (
                        <div
                          style={{
                            border: "1px solid #e3efe7",
                            borderRadius: "10px",
                            overflow: "hidden",
                            background: "#fff",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              background: "#f8f9f9",
                              display: "flex",
                              alignItems: "center",
                              padding: "10px 12px",
                              borderBottom: "1px solid #e3efe7",
                              gap: "12px",
                            }}
                          >
                            <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                              <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                            </div>
                            <span
                              style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                color: "#205a46",
                                textTransform: "uppercase",
                                flex: 1,
                              }}
                            >
                              {it.tableTitle || "Table"}
                            </span>
                          </div>
                          <div style={{ background: "#fff", padding: 0 }}>
                            <TemplateTableGenerator
                              isDisclosureTable={true}
                              tableId={it.id}
                              forceOpen={it.isTemp ? it.forceOpen : it.id === forceOpenTableId}
                              onAfterOpen={() => {
                                if (it.isTemp) {
                                  setBottomBlocks((prev) => prev.map((b) => b.id === it.id ? { ...b, forceOpen: false } : b));
                                }
                              }}
                              onCancel={() => {
                                if (it.isTemp) {
                                  removeItem(it.id);
                                }
                              }}
                              value={{
                                tableTitle: it.tableTitle,
                                tableRow: it.tableRow,
                                tableColumn: it.tableColumn,
                                tableType: it.tableType,
                                table: getVisibleStandaloneTableRows(it.table),
                                hasCellData: it.hasCellData,
                              }}
                              onChange={(next) => {
                                const previousRows = it.tableData || it.table || [];
                                const nextRows = next.tableData || [];
                                if (
                                  nextRows.length > previousRows.length &&
                                  isStandaloneBlankRow(nextRows[nextRows.length - 1])
                                ) {
                                  skipStandaloneTableSaveOnceRef.current[it.id] = true;
                                }
                                updateTableItem(it.id, {
                                  tableTitle: next.tableTitle,
                                  tableRow: next.tableRow || it.tableRow,
                                  tableColumn: next.tableColumn,
                                  hasCellData: next.hasCellData,
                                  tableData: next.tableData,
                                  tableType: next.tableType,
                                });
                              }}
                              onCellBlur={() => {
                                queueStandaloneTableSave(it.id);
                              }}
                              onSaveStructure={(next) => {
                                handleTableBlockChange(it.id, next);
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          padding: 12,
          borderRadius: 12,
          marginTop: 12,
        }}
      >
        <CirclePlus width={37} />
        <AddEditor width={140} onClick={handleAddParagraph} style={{ cursor: "pointer" }} />
        <AddTable width={100} onClick={handleAddTableWithoutModal} style={{ cursor: "pointer" }} />
      </div>
    </div>
  );

  const updateEditorContent = (id, newContent) => {
    setBottomBlocks((prev) =>
      prev.map((b) =>
        b.id === id ? { ...b, text: [{ content: newContent }] } : b
      )
    );
  };

  const updateTableItem = (id, patch) => {
    setBottomBlocks((prev) =>
      prev.map((b) => (b.id === id ? { ...b, ...patch } : b))
    );
  };

  const onDragEndItems = (result) => {
    if (!result.destination) return;
    const items = Array.from(bottomBlocks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setBottomBlocks(items);
  };
  const [loadingCount, setLoadingCount] = useState(0);
  const isLoading = loadingCount > 0;

  const [showLinkPanel, setShowLinkPanel] = useState(false);
  const [selectedCell, setSelectedCell] = useState(null);
  const [activeCellKey, setActiveCellKey] = useState(null);
  const [panelDataID, setPanelDataID] = useState(null);

  const project_id = localStorage.getItem("project_id");

  const handleCellLinkClick = (row, col, tableID, isLinked) => {
    const normalize = (v) => String(v || "").trim().toLowerCase();
    const rowName = normalize(row.particular);
    const colName = col.field;
    const currentRowId = row.rowId || row._id || tableID;
    
    const key = `${subMenuId || ''}-${currentRowId || ''}-${rowName}-${colName}`;
    
    setSelectedCell({ row: row.particular, rowId: currentRowId, col: colName });
    setPanelDataID(activeCat === "disclosure" ? tableID : currentRowId);
    setActiveCellKey(key);
    setShowLinkPanel(true);
  };

  const filteredColumns = columns.filter(
    c => c.field !== "cellFormulas"
  );

  const getAllCellFormulas = (data) => {
    let formulas = [];
    const walk = (node) => {
      if (node.cellFormulas && Array.isArray(node.cellFormulas)) {
         formulas = formulas.concat(node.cellFormulas);
      }
      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
      if (node.data && node.data.length) {
        node.data.forEach(walk);
      }
    };
    if (Array.isArray(data)) {
       data.forEach(walk);
    } else if (data) {
       walk(data);
    }
    return formulas;
  };

  useEffect(() => {
    localStorage.setItem("activeCat", activeCat);
  }, [activeCat]);

  useEffect(() => {
    localStorage.setItem("showCashflowWorkings", showCashflowWorkings ? "true" : "false");
  }, [showCashflowWorkings]);

  // ── Sync rows from the correct source depending on category ───────────────
  useEffect(() => {
    if (activeCat === "BS" || activeCat === "PL") {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else if (["general notes", "BS notes", "PL notes", "disclosure"].includes(activeCat)) {
      setRows(fsNotesResponseData ?? []);
    } else {
      setRows(loadData ?? []);
    }
  }, [loadData, fsNotesResponseData, activeCat]);

  useEffect(() => {
  if (activeCat !== "cashflow") {
    setShowCashflowWorkings(false);
    setShowAdjustmentLog(false);
  }
}, [activeCat]);


  // ── Set columns / isNotes / subMenu based on activeCat and rows ───────────
  useEffect(() => {
    setColumns([]);

    // BS / PL
    if (activeCat === "BS" || activeCat === "PL") {
      setIsNotes(false);
      setSubMenu(null);
      setColumns([
        {
          label: "Particular",
          field: "particular",
          align: "left",
          editable: false,
          width: "70%",
        },
        {
          label: "Notes",
          field: "notes",
          align: "center",
          editable: false,
          type: "redirect",
          width: 100,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          label: "Current Year",
          field: "currentYear",
          align: "right",
          editable: false,
          type: "number",
          width: 200,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          label: "Previous Year",
          field: "previousYear",
          align: "right",
          editable: false,
          type: "number",
          width: 200,
          minWidth: 200,
          maxWidth: 200,
        },
      ]);
      return;
    }

    // SOCIE / Cashflow
    if (["socie", "cashflow"].includes(activeCat)) {
      setIsNotes(false);
      setSubMenu(null);

      if (rows.length > 0) {
        const catRows = Object.keys(rows[0] || {});

        // Reorder: Put Years at the end and remove baseCurrentYear
        const sortedRows = [
          ...catRows.filter((c) => {
            const lower = String(c).toLowerCase().trim();
            return !["_id", "linetype", "line type", "line-type", "lineitem", "reference", "references", "isbold", "formulatype", "currentyear", "previousyear", "basecurrentyear", "derivedfromworkings", "groupingid", "grouping id"].includes(lower);
          }),
          ...catRows
            .filter((c) =>
              ["currentYear", "previousYear"].includes(c)
            )
            .sort((a, b) => {
              if (a === "currentYear") return -1;
              return 1;
            }),
        ];

        const tableCols = sortedRows.map((item) => {
          let alignValue = "left";
          const lowerItem = item.toLowerCase();

          if (lowerItem === "currentyear" || lowerItem === "previousyear") {
            alignValue = "right";
          }

          if (activeCat === "socie" && lowerItem !== "particular") {
            alignValue = "right";
          }

          let colWidth = 300;
          let minColWidth = 300;
          let maxColWidth = undefined;

          if (lowerItem === "currentyear" || lowerItem === "previousyear") {
            colWidth = 200;
            minColWidth = 200;
            maxColWidth = 200;
          } else if (lowerItem === "particular") {
            colWidth = "70%";
            minColWidth = 500;
          } else if (activeCat === "socie") {
            colWidth = 220;
            minColWidth = 220;
            maxColWidth = 220;
          }

          return {
            label: item,
            field: item,
            align: alignValue,
            editable: true,
            type: "text",
            width: colWidth,
            minWidth: minColWidth,
            maxWidth: maxColWidth,
            headerStyle: {
              width: colWidth,
              minWidth: minColWidth,
              maxWidth: maxColWidth,
              textAlign: alignValue,
              whiteSpace: activeCat === "socie" && lowerItem !== "particular" ? "normal" : "nowrap",
            },
          };
        });

        setColumns(tableCols);
      }
      return;
    }

    // Notes categories
    if (
      ["general notes", "BS notes", "PL notes", "disclosure", "checklist"].includes(activeCat)
    ) {
      setIsNotes(true);
      const submenuArray = rows.map((item) => ({
        label: item.particular,
        value: item._id,
        subGroup: item.subgroup,
      }));

      setSubMenu({
        category: activeCat,
        submenu: submenuArray,
      });

      // Auto-select first item if none selected
      if (submenuArray.length > 0 && !subMenuId) {
        setSubMenuId(submenuArray[0].value);
      }
      
      setColumns([]);
      return;
    }

    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows, subMenuId]);


  const handleRowsChange = (updatedRows, tableId) => {
    if (isNotes) {
      const params = {
        category: activeCat,
        projectID: project_id,
        groupID: subMenuId,
        subgroupID: tableId,
      };

      // Strip internal fields before sending to API
      const cleanRows = updatedRows.map(({ isNewRow, ...rest }) => rest);
      const payload = {
        table: cleanRows,
      };

      // Use replaceNotesTable for categories that support add/delete/rearrange
     const useReplaceApi = [
        "general notes",
        "disclosure",
        "cashflowWorkings"
      ].includes(activeCat);
      const apiCall = useReplaceApi
        ? replaceNotesTableApiHandler(params, payload)
        : updatePopulateFSApiHandler(params, payload);

      apiCall
        .then((response) => {
          if (response?.data?.success === true) {
            if (useReplaceApi) {
              // Refresh to get server-assigned IDs for new/reordered rows
              getPopulateFSNotes(activeCat);
            } else {
              setFsNotesResponseData((prev) =>
                (prev || []).map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map((sg) => {
                      if (sg._id !== tableId) return sg;
                      return {
                        ...sg,
                        table: updatedRows,
                      };
                    }),
                  };
                })
              );
            }
          } else {
            swal("Error", response?.data?.error || "Unable to update the data", "error");
          }
        })
        .catch((error) => {
          swal("Error", error?.response?.data?.error || "Unable to save the data", "error");
        });
    } else {
      if (activeCat === "socie") {
        // SOCIE: any row change (edit) — replace all rows
        const cleanRows = (updatedRows || []).map(({ isNewRow, _id, ...rest }) => rest);
        replaceSocieApiHandler(project_id, cleanRows)
          .then(() => getPopulateFS("socie"))
          .catch((err) => console.error("replaceSocie error", err));
      } else if (activeCat === "cashflow") {
        // Cashflow: plain cell edits only (not add/delete/reorder handled separately)
        setLoadData(updatedRows);
      }
    }
  };

  // ── SOCIE helpers ─────────────────────────────────────────────────────
  const handleSocieRowAdd = (rowIdx, row) => {
    // FSTable triggers onRowAdd with the newly sealed row. 
    // The parent's `rows` state does not contain this row yet, so we must insert it.
    const newRows = [...(rows || [])];
    newRows.splice(rowIdx, 0, row);
    
    const cleanRows = newRows.map(({ isNewRow, _id, ...rest }) => rest);
    replaceSocieApiHandler(project_id, cleanRows)
      .then(() => getPopulateFS("socie"))
      .catch((err) => console.error("replaceSocie add error", err));
  };

  const handleSocieRowDelete = (rowIdx, updatedRows) => {
    const cleanRows = (updatedRows || []).map(({ isNewRow, _id, ...rest }) => rest);
    replaceSocieApiHandler(project_id, cleanRows)
      .then(() => getPopulateFS("socie"))
      .catch((err) => console.error("replaceSocie delete error", err));
  };

  const handleSocieRowReorder = (fromIndex, toIndex, updatedRows) => {
    const cleanRows = (updatedRows || []).map(({ isNewRow, _id, ...rest }) => rest);
    replaceSocieApiHandler(project_id, cleanRows)
      .then(() => getPopulateFS("socie"))
      .catch((err) => console.error("replaceSocie reorder error", err));
  };

  // ── Cashflow helpers ─────────────────────────────────────────────────
  const handleCashflowRowAdd = (position, row) => {
    const payload = {
      particular: row.particular || "",
      lineType: row.lineType || "line item",
      position,
    };
    addCashflowRowApiHandler(project_id, payload)
      .then(() => getPopulateFS("cashflow"))
      .catch((err) => console.error("addCashflowRow error", err));
  };

  const handleCashflowRowDelete = (rowIdx, updatedRows) => {
    // Delete: replace all — use replaceSocie pattern but for cashflow rows
    // No dedicated delete API provided; re-add all rows by dropping deleted one
    // using addCashflowRow is not practical for delete; just refresh for now
    getPopulateFS("cashflow");
  };

  const handleCashflowRowReorder = (fromIndex, toIndex) => {
    rearrangeCashflowRowApiHandler(project_id, fromIndex, toIndex)
      .then(() => getPopulateFS("cashflow"))
      .catch((err) => console.error("rearrangeCashflowRow error", err));
  };

  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "Cashflow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "General Notes", value: "general notes" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "P&L Statement Notes", value: "PL notes" },
    { label: "Disclosures", value: "disclosure" },
    //{ label: "Disclosures Checklist", value: "checklist" },
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      projectID: project_id,
    };
    setLoadingCount(prev => prev + 1);
    return getPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          setLoadData(catData);
        }
      })
      .catch((error) => {
        setLoadData([]);
      })
      .finally(() => {
        setLoadingCount(prev => Math.max(0, prev - 1));
      });
  };

  const refreshStandaloneCategoryData = async (category = activeCat) => {
    await getPopulateFS(category);
    if (["BS notes", "PL notes", "general notes", "disclosure"].includes(category)) {
      await getPopulateFSNotes(category);
    }
  };

  // ── Fetch data whenever activeCat changes ─────────────────────────────────
  useEffect(() => {
    setLoadingCount(prev => prev + 1); // Set loading immediately
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setSubMenuId(null);
    setLoadData([]);
    setFsNotesResponseData(null);
    setRows([]);
    
    const fetchData = async () => {
      try {
        const catToUse = (activeCat === "cashflow" && showCashflowWorkings) ? "cashflowWorkings" : activeCat;
        await getPopulateFS(catToUse);
        if ([
          "BS notes",
          "PL notes",
          "general notes",
          "disclosure",
          "cashflowWorkings",
        ].includes(catToUse)) {
          await getPopulateFSNotes(catToUse);
        }
      } finally {
        setLoadingCount(prev => Math.max(0, prev - 1));
      }
    };

    fetchData();
  }, [activeCat, showCashflowWorkings]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    const params = {
      category: activeCat,
      projectID: project_id,
    };

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;
      payload["textRaw"] = key;
      payload["textPlain"] = value;
    } else {
      payload[key] = value;
    }

    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          if (isNotes) {
            if (type === "text") {
              // ── Update fsNotesResponseData (source of truth for notes) ────
              setFsNotesResponseData((prev) =>
                (prev || []).map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              // ── Update fsNotesResponseData (source of truth for notes) ────
              setFsNotesResponseData((prev) =>
                (prev || []).map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== subgroupId) return sg;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, socie, cashflow)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      handleTableEdit(args);
    }, 2000);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current);
  }, []);

 const ShowDetails = () => {

  const formatIndianNumber = (val) => {
    if (val == null) return "";
    const num = Number(val);
    if (isNaN(num)) return val;

    if (num < 0) {
      return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
    }
    return num.toLocaleString("en-IN");
  };

  const formattedRows =
    activeCat === "socie" || activeCat === "cashflow"
      ? rows.map((row) => {
          const newRow = { ...row };

          Object.keys(newRow).forEach((key) => {
            if (
              key !== "_id" &&
              key !== "lineType" &&
              key !== "references" &&
              newRow[key] !== null &&
              newRow[key] !== undefined &&
              !isNaN(Number(newRow[key]))   
            ) {
              newRow[key] = formatIndianNumber(newRow[key]);
            }
          });

          return newRow;
        })
      : rows;

  return (
    <FSTable
      columns={filteredColumns}
      rows={formattedRows}
      onRowsChange={handleRowsChange}
      onCellChangeImmediate={handleTableEditDebounced}
      redirectTo={redirectTo}
      enableHoverLink={activeCat === "socie" || activeCat === "cashflow"}
      hoverLinkColumns={activeCat === "cashflow" ? ['currentYear', 'previousYear'] : true}
      cellFormulas={getAllCellFormulas(loadData)}
      onCellLinkClick={handleCellLinkClick}
      selectedCell={selectedCell}
      showLinkPanel={showLinkPanel}
      tableDataID={loadData?.[0]?._id}
      activeCat={activeCat}
      allowDragAndAdd={
        !["BS", "PL", "BS notes", "PL notes", "checklist"].includes(activeCat)
      }
      onRowAdd={
        activeCat === "socie"
          ? handleSocieRowAdd
          : activeCat === "cashflow"
          ? handleCashflowRowAdd
          : null
      }
      onRowDelete={
        activeCat === "socie"
          ? handleSocieRowDelete
          : activeCat === "cashflow"
          ? handleCashflowRowDelete
          : null
      }
      onRowReorder={
        activeCat === "cashflow"
          ? handleCashflowRowReorder
          : activeCat === "socie"
          ? handleSocieRowReorder
          : null
      }
    />
  );
};

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: true,
        type: "text",
        placeholder: "Enter remarks here...",
      },
    ];

    return (
      <>
        <FSTable
          columns={checklistColumns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      setLoadingCount(prev => prev + 1);
      const getParams = {
        category: cat,
        projectID: project_id,
      };

      const response = await getPopulateFSDetailsApiHandler(getParams);

      if (response?.data?.success === true) {
        setFsNotesResponseData(response.data.data);
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    } finally {
      setLoadingCount(prev => Math.max(0, prev - 1));
    }
  };

  const triggerRedirectSearch = (searchPayload, sourceRows) => {
    const searchArg = String(searchPayload.arg || "").trim().toLowerCase();
    const searchPart = String(searchPayload.particular || "").trim().toLowerCase();

    const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
    const normPart = normalize(searchPart);

    let foundNoteId = null;
    let foundSubGroupId = null;

    // 1. Try to find the Note Header
    const directMatch = sourceRows.find(item => {
      const itemName = String(item.particular || "").trim().toLowerCase();
      const itemNote = String(item.notes || "").trim().toLowerCase();
      const normItemName = normalize(itemName);

      return (
        (normPart && (normItemName === normPart || normItemName.includes(normPart) || normPart.includes(normItemName))) ||
        (searchArg && (itemNote === searchArg || itemNote.includes(searchArg))) ||
        (searchPart && (itemName === searchPart || itemName.includes(searchPart)))
      );
    });

    if (directMatch) {
      foundNoteId = directMatch._id;
      
      // 2. Try to find the specific subgroup/table inside that note
      const sgs = directMatch.subgroup || directMatch.subGroup || [];
      const matchingSg = sgs.find(sg => {
        const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
        const normTitle = normalize(title);
        return (
          (normPart && normTitle === normPart) ||
          title.includes(searchPart) || 
          searchPart.includes(title)
        );
      });
      if (matchingSg) foundSubGroupId = matchingSg._id;
    } else {
      // 3. Fallback: Search across all subgroups if Note Header didn't match
      for (const item of sourceRows) {
        const sgs = item.subgroup || item.subGroup || [];
        const foundSg = sgs.find(sg => {
          const title = String(sg.tableTitle || sg.particular || "").toLowerCase();
          const normTitle = normalize(title);
          return (normPart && normTitle === normPart) || title.includes(searchPart) || searchPart.includes(title);
        });
        if (foundSg) {
          foundNoteId = item._id;
          foundSubGroupId = foundSg._id;
          break;
        }
      }
    }

    if (foundNoteId) {
      setSubMenuId(foundNoteId);
      setRedirectNote(foundNoteId);
      if (foundSubGroupId) {
        setTargetSubGroupId(foundSubGroupId);
        setSubGroupId(foundSubGroupId);
      }
      setRedirectSearch(null);
    } else if (activeCat === searchPayload.targetCat && sourceRows.length > 0) {
      setRedirectSearch(null);
    }
  };

  const redirectTo = (arg, row) => {
    let targetCat = null;

    if (activeCat === "BS") {
      targetCat = "BS notes";
    } else if (activeCat === "PL") {
      targetCat = "PL notes";
    } else {
      targetCat = activeCat;
    }

    if (targetCat) {
      const searchPayload = {
        arg: arg,
        particular: row?.particular,
        targetCat: targetCat
      };
      setRedirectSearch(searchPayload);
      
      if (targetCat === activeCat) {
        triggerRedirectSearch(searchPayload, fsNotesResponseData || []);
      } else {
        setActiveCat(targetCat);
      }
    }
  };

  useEffect(() => {
    if (!redirectSearch || activeCat !== redirectSearch.targetCat || !isNotes || !fsNotesResponseData) return;
    triggerRedirectSearch(redirectSearch, fsNotesResponseData);
  }, [redirectSearch, isNotes, fsNotesResponseData, activeCat]);

  useEffect(() => {
    if (targetSubGroupId && isNotes) {
      const timer = setTimeout(() => {
        // Try to scroll to specific row first
        const normalize = (str) => String(str || "").replace(/[^a-z0-9]/gi, "").toLowerCase();
        const rowId = redirectSearch?.particular ? normalize(redirectSearch.particular) : null;
        
        const rowElement = rowId ? document.getElementById(rowId) : null;
        const tableElement = document.getElementById(targetSubGroupId);
        
        const element = rowElement || tableElement;

        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add(commoncss.noteSectionHighlight);
          setTimeout(() => element.classList.remove(commoncss.noteSectionHighlight), 2000);
          setTargetSubGroupId(null);
        }
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [targetSubGroupId, isNotes, subMenuId]);

  // ── FIX: depend on fsNotesResponseData + subMenuId, NOT on rows ───────────
  // Previously `rows` was in the dep array which caused this to re-run
  // whenever rows changed (often), and at that moment fsNotesResponseData
  // could still be null → selNote = undefined → notesData wiped incorrectly.
  useEffect(() => {
    console.log("=== subMenuId ===", subMenuId);
    console.log("=== fsNotesResponseData ===", fsNotesResponseData);
    console.log("=== isNotes ===", isNotes);
    console.log("=== activeCat ===", activeCat);

    if (!isNotes && !(activeCat === "cashflow" && showCashflowWorkings)) {
      setNotesData(null);
      return;
    }
    if (activeCat === "checklist") {
      setNotesData(null);
      return;
    }

    const source = fsNotesResponseData ?? [];
    if (activeCat === "cashflow" && showCashflowWorkings) {
      if (!subMenuId) {
        setNotesData(source[0] || null);
        return;
      }
    }

    if (!subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = source.find((item) => item._id === subMenuId) || null;
    
    console.log("=== selNote found ===", selNote);
    setNotesData(selNote);
  }, [isNotes, activeCat, showCashflowWorkings, subMenuId, fsNotesResponseData]);
  // ─────────────────────────────────────────────────────────────────────────

  // ── Auto-select first table subgroup within a note ────────────────────────
  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    const subGroups = notesData.subgroup || notesData.subGroup || [];
    const firstTableSg = subGroups.find(
      (sg) => (sg?.dataType ?? sg?.datatype) === "table"
    );

    setSubGroupId(firstTableSg?._id ?? null);
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      const getParams = {
        category: activeCat,
        projectID: project_id,
        groupID: subMenuId,
        subgroupID: subgroupID,
      };

      await deletePopulateFSApiHandler(getParams);

      setUpdateTrigger((prev) => prev + 1);
      const delEl = document.getElementById(subgroupID);
      if (delEl) delEl.style.display = "none";
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  // ── Re-sync notesData after a delete (updateTrigger bump) ─────────────────
  // Also reads from fsNotesResponseData, not rows
  useEffect(() => {
    if (!isNotes && !(activeCat === "cashflow" && showCashflowWorkings)) {
      setNotesData(null);
      return;
    }
    if (activeCat === "checklist") {
      setNotesData(null);
      return;
    }

    const source = fsNotesResponseData ?? [];
    if (activeCat === "cashflow" && showCashflowWorkings) {
      if (!subMenuId) {
        setNotesData(source[0] || null);
        return;
      }
    }

    if (!subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = source.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);
  }, [updateTrigger, isNotes, activeCat, showCashflowWorkings, subMenuId, fsNotesResponseData]);
  // ─────────────────────────────────────────────────────────────────────────

  const renderSubGroups = (notesData) => {
    const subGroups = notesData?.subgroup || notesData?.subGroup || [];

    const relatedTables = [];
    const normalTables = [];
    let relatedPartyTitle = "";

    subGroups.forEach((sg, idx) => {
      console.log("----- TABLE DEBUG -----");
      console.log("Category:", activeCat);
      console.log("Data Type:", sg?.dataType ?? sg?.datatype);
      console.log("Table Type:", sg?.tableType);
      console.log("Table Rows:", sg?.table?.length);
      console.log("Is Related Party:", sg?.tableType === "related party");
      console.log("-----------------------");

      const type = sg?.dataType ?? sg?.datatype ?? "";

      const isCustom = sg?.isCustom === true;
      if (activeCat === "cashflow" && showCashflowWorkings && type === "table" && !isCustom) {
        return;
      }

      if (type === "table") {
        const formatIndianNumber = (val) => {
        if (val == null) return "";
        const num = Number(val);
        if (isNaN(num)) return val;

        if (num < 0) {
          return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
        }
        return num.toLocaleString("en-IN");
      };

      const isNotesTable =
        activeCat === "BS notes" || activeCat === "PL notes";

      const tableItems = (Array.isArray(sg.table) ? sg.table : []).map((row) => {
        if (!isNotesTable) return row;

        const newRow = { ...row };

        Object.keys(newRow).forEach((key) => {
          if (
            key !== "_id" &&
            key !== "references" &&
            key !== "particular" &&
            key !== "lineType" &&
            newRow[key] !== null &&
            newRow[key] !== undefined &&
            !isNaN(Number(newRow[key]))
          ) {
            newRow[key] = formatIndianNumber(newRow[key]);
          }
        });

        return newRow;
      });

      const itemsToRender = tableItems.length > 0 
        ? tableItems 
        : [ (sg.tableColumn || []).reduce((acc, col) => ({ ...acc, [col.name]: "" }), {}) ];

      const catRows = Object.keys(itemsToRender[0] || {});
      const filteredCols = catRows.filter((col) => col !== "_id");

      const orderedCols = isNotesTable
        ? [
            ...filteredCols.filter((col) => {
              const lower = col.toLowerCase();
              return ![
                "references",
                "linetype",
                "line type",
                "line-type",
                "isbold",
                "formulatype",
                "currentyear",
                "previousyear",
                "derivedfromworkings",
                "isnewrow"
              ].includes(lower);
            }),
              ...filteredCols
                .filter((col) => {
                  const lower = col.toLowerCase();
                  return lower === "currentyear" || lower === "previousyear";
                })
                .sort((a, b) => {
                  if (a.toLowerCase() === "currentyear") return -1;
                  return 1;
                }),
            ]
          : [
              ...filteredCols.filter((col) => {
                const lower = String(col).toLowerCase().trim();
                const isLineType = lower === "linetype" || lower === "line type" || lower === "line-type";
                const isBold = lower === "isbold";
                const isFormulaType = lower === "formulatype";
                return col !== "references" && !isLineType && !isBold && !isFormulaType && lower !== "derivedfromworkings" && lower !== "groupingid" && lower !== "grouping id";
              }),
            ];

    const tableCols = orderedCols.map((col) => {
  if (col === "references") {
    return {
      label: col,
      field: col,
      align: "left",
      editable: false,
      type: "checklistref",
    };
  }

  const isNotesTable =
    activeCat === "BS notes" || activeCat === "PL notes";

  const lowerCol = col.toLowerCase();

  // ✅ Identify columns
  const isParticular = lowerCol === "particular";
  const isLineType =
    lowerCol === "linetype" || lowerCol === "line type";
if (isNotesTable) {
  return {
    label: col,
    field: col,

    align: isParticular || isLineType ? "left" : "right",

    editable: true,
    type: "text",


    width: isParticular
      ? "85%"
      : isLineType
      ? 200
      : 80,

    minWidth: isParticular
      ? 600
      : isLineType
      ? 200
      : 80,

    maxWidth: isParticular
      ? "85%"
      : isLineType
      ? 200
      : 80,

   
    headerStyle: {
      width: isParticular
        ? "85%"
        : isLineType
        ? 200
        : 80,
      minWidth: isParticular
        ? 600
        : isLineType
        ? 200
        : 80,
      maxWidth: isParticular
        ? "85%"
        : isLineType
        ? 200
        : 80,
      textAlign: isParticular || isLineType ? "left" : "right",
    },
  };
}
 
 
  const isPercentage =
    lowerCol.includes("percentage") || lowerCol.includes("%");

  const hasNumericData =
    activeCat === "disclosure" &&
    sg?.tableType !== "related party" &&
    tableItems.some((row) => {
      const v = row[col];
      return v !== null && v !== "" && !isNaN(Number(v));
    });

  const isTextDefault =
    lowerCol.includes("particular") ||
    lowerCol.includes("name") ||
    (lowerCol.includes("relationship") && sg?.tableType === "related party") ||
    lowerCol.includes("description") ||
    (activeCat === "disclosure" &&
      sg?.tableType !== "related party" &&
      !hasNumericData);

  const defaultAlign = isTextDefault && !isPercentage ? "left" : "right";
  
  const isParticularCol = lowerCol.includes("particular");
  const isDateCol = lowerCol === "date";

  return {
    label: col,
    field: col,
    align: defaultAlign,
    editable: true,
    type: isPercentage || defaultAlign === "right" ? "number" : "text",
    width: isParticularCol ? "40%" : (isDateCol ? 80 : "auto"),
    minWidth: isParticularCol ? 300 : (isDateCol ? 80 : (defaultAlign === "right" ? 120 : 150)),
    maxWidth: isParticularCol ? "60%" : (isDateCol ? 80 : undefined),
  };
});
        const isDisclosure = activeCat === "disclosure";
        const disclosureHoverColumns = tableCols
          .filter((col) => col.align === "right")
          .map((col) => col.field);
        const tableComponent = (
          <FSTable
            key={sg._id}
            columns={tableCols}
            rows={tableItems}
            onRowsChange={(updated) => handleRowsChange(updated, sg._id)}
            onCellChangeImmediate={handleTableEditDebounced}
            redirectTo={redirectTo}
            tableTitle={sg?.tableTitle}
            tableId={sg?._id}
            tableType={sg?.tableType}
            deletePopulateFS={["BS notes", "PL notes", "general notes", "disclosure"].includes(activeCat) ? null : undefined}
            enableHoverLink={isDisclosure}
            hoverLinkColumns={isDisclosure ? disclosureHoverColumns : []}
            cellFormulas={sg.cellFormulas || []}
            onCellLinkClick={handleCellLinkClick}
            tableDataID={sg._id}
            allowDragAndAdd={
              !["BS", "PL", "BS notes", "PL notes", "checklist"].includes(activeCat)
            }
          />
        );

        if (sg?.tableType === "related party") {
          const relatedTableComponent = (
            <div 
              key={sg._id} 
              className={bookclosurecss.relatedTableWrapper}
              style={{ borderRadius: activeCat === "disclosure" ? "0px" : "10px" }}
            >
              {activeCat !== "disclosure" && (
                <div className={bookclosurecss.relatedTableTitle}>
                  {sg?.tableTitle || "Related party disclosures"}
                </div>
              )}
              <div
                className={bookclosurecss["relatedTable-content"]}
                style={{
                  borderRadius:
                    activeCat === "disclosure" ? "0px 0px 12px 12px" : "12px",
                  padding: 0,
                  margin: 0
                }}
              >
                <FSTable
                  columns={tableCols}
                  rows={tableItems}
                  onRowsChange={(updated) => handleRowsChange(updated, sg._id)}
                  onCellChangeImmediate={handleTableEditDebounced}
                  redirectTo={redirectTo}
                  tableTitle={activeCat === "disclosure" ? null : sg?.tableTitle}
                  tableId={sg?._id}
                  tableType={sg?.tableType}
                  deletePopulateFS={["BS notes", "PL notes", "general notes", "disclosure"].includes(activeCat) ? null : undefined}
                  allowDragAndAdd={
                    !["BS", "PL", "BS notes", "PL notes", "checklist"].includes(activeCat)
                  }
                />
              </div>
            </div>
          );
          relatedTables.push(relatedTableComponent);
        } else {
          normalTables.push(tableComponent);
        }
      }

      if (type === "text") {
        normalTables.push(
          <div key={sg._id} style={{ paddingTop: "20px"}}>
            <QuillReactEditor
              key={sg._id}   
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                handleTableEdit({
                  _id: sg?._id,
                  key: content.html,
                  value: content.text,
                  type: "text",
                });
              }}
            />
          </div>
        );
      }
    });

    return (
      <>
        {relatedTables.length > 0 && (
          <ViewRPTTransactions
            apiResponseData={fsNotesResponseData}
            getPopulateFSNotes={getPopulateFSNotes}
            notesData={notesData}
            tableTitle={relatedPartyTitle}
          >
            {relatedTables}
          </ViewRPTTransactions>
        )}
        {normalTables}
      </>
    );
  };

  const [showAdjustmentLog, setShowAdjustmentLog] = useState(false);
  const formatIndianNumber = (val) => {
  if (val == null) return "";
  const num = Number(val);
  if (isNaN(num)) return val;

  if (num < 0) {
    return "(" + Math.abs(num).toLocaleString("en-IN") + ")";
  }
  return num.toLocaleString("en-IN");
};

  const transformData = (data) => {
    const output = [];

    const walk = (node) => {
      if (node.level === 3) return;
      const type = (node.level === 1 && (activeCat === "BS" || activeCat === "PL")) ? (node.lineType || "row") : (node.level === 1 ? "header" : "row");

      output.push({
        _id: node._id,
        lineType: type,
        originalLineType: node.lineType,
        level: node.level,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? [],
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
    };

    data.forEach(walk);
    return output;
  };

  return (
    <>
      <div className={`${workSpaceCss.df}`}>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <FSSideMenu
              title="Financial Statements"
              menuItems={menuItems}
              subMenu={subMenu}
              activeCat={activeCat}
              setActiveCat={setActiveCat}
              setSubMenuId={setSubMenuId}
              showNotesDetails={showNotesDetails}
              redirectNote={redirectNote}
              setRedirectNote={setRedirectNote}
              subMenuId={subMenuId}
              isLoading={isLoading}
            />
          </motion.div>
          <div
            className={bookclosurecss.bookClosureContent}
            style={{ width: activeCat === "checklist" ? "83vw" : "85vw" }}
          >

           <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
            <FSTopBar history={history} activeCat={activeCat} 
            showCashflowWorkings={showCashflowWorkings}
              onToggleCashflowWorkings={
                activeCat === "cashflow"
                  ? () => setShowCashflowWorkings((prev) => !prev)
                  : undefined
              }
               showAdjustmentLog={showAdjustmentLog}
               showAddAdjustment={showAddAdjustment} 
               onOpenAdjustmentLog={() => setShowAdjustmentLog(true)} 
               onBackFromAdjustmentLog={() => {
                  setShowAdjustmentLog(false);
                  setShowAddAdjustment(false); 
                }}
                onAddAdjustment={() => {
                  setShowAdjustmentLog(true);
                  setShowAddAdjustment(true);
                }}
             />
          </div>

            <div
              className={`${
                activeCat === "cashflow" && showCashflowWorkings
                  ? bookclosurecss.cashflowHideScroll   
                  : ""
              } ${bookclosurecss.tableLoadingWrapper} standalone-scroll-container`}
              style={{
                height: "88vh",
                overflowY: "auto",
                overflowX:
                  activeCat === "cashflow" && showCashflowWorkings
                    ? "auto"
                    : "hidden",
                padding: "0px 20px",
                width:
                  activeCat === "cashflow" && showCashflowWorkings
                    ? "84vw"
                    : activeCat === "socie"
                    ? "100%"
                    : "auto",
              }}
            >
              {isLoading && (
                <div className={bookclosurecss.tableLoaderOverlay}>
                  <div className={bookclosurecss.tableLoaderDiv}>
                    <Spinner animation="grow" size="sm" />
                    <Spinner animation="grow" style={{ margin: "1rem" }} />
                    <Spinner animation="grow" size="sm" />
                  </div>
                </div>
              )}
             {activeCat === "cashflow" && showCashflowWorkings ? (
                <>
                  {showAdjustmentLog ? (
                      showAddAdjustment ? (
                        <AddNewAdjustment
                        projectID={project_id}
                        onBack={() => {
                          setShowAddAdjustment(false);
                          setShowAdjustmentLog(false);
                        }}/>
                      ) : (
                        <AdjustmentLog onAdd={() => setShowAddAdjustment(true)} />
                      )
                    ) : (
                     
                         <CashflowWorkings
                            groupingTemplateID={project_id}
                            cashflowWorkingsID={subMenuId}
                            dataID={subgroupId}
                            autoSave={true}
                            isStandalone={true}
                          />
      
                    )}
                  
                  {notesData && (
                    <div className="cashflow-custom-blocks">
                      {renderSubGroups(notesData)}
                    </div>
                  )}

                  {/* ── Text editor / add-table blocks — outside the table container ── */}
                  <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
                    <DragDropContext onDragEnd={onDragEndItems}>
                      <Droppable droppableId="standalone-bottom-items">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{ display: "grid", gap: 20 }}
                          >
                            {bottomBlocks.map((it, idx) => (
                              <Draggable key={it.id} draggableId={it.id} index={idx}>
                                {(dragProvided) => (
                                  <div
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    style={{
                                      ...dragProvided.draggableProps.style,
                                      width: "100%",
                                    }}
                                  >
                                    {it.type === "text" ? (
                                      <QuillReactEditor
                                        value={it.text?.[0]?.content ?? " "}
                                        onChange={(content) => {
                                          updateEditorContent(it.id, content);
                                        }}
                                        dragHandleProps={dragProvided.dragHandleProps}
                                        rightControl={null}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          border: "1px solid #e3efe7",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          background: "#fff",
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          style={{
                                            background: "#f8f9f9",
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            borderBottom: "1px solid #e3efe7",
                                            gap: "12px",
                                          }}
                                        >
                                          <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                                            <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                                          </div>
                                          <span
                                            style={{
                                              fontWeight: 600,
                                              fontSize: "13px",
                                              color: "#205a46",
                                              textTransform: "uppercase",
                                              flex: 1,
                                            }}
                                          >
                                            {it.tableTitle || "Table"}
                                          </span>

                                        </div>
                                       
                                      </div>
                                    )}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>

                    <div
                      style={{
                        display: "flex",
                        gap: 12,
                        alignItems: "center",
                        padding: 12,
                        borderRadius: 12,
                        marginTop: 12,
                      }}
                    >
                      <CirclePlus width={37} />
                      <AddEditor width={140} onClick={handleAddParagraph} style={{ cursor: "pointer" }} />
                      <AddTable width={100} onClick={handleAddTableWithoutModal} style={{ cursor: "pointer" }} />
                    </div>

                    {isAddingTable && (
                      <div style={{ marginTop: "12px", position: "relative" }}>
                        {isSavingTable && (
                          <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.7)", zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px" }}>
                            <div style={{ textAlign: "center" }}>
                              <Spinner animation="border" role="status" style={{ color: "#205a46", marginBottom: "10px" }} />
                              <div style={{ color: "#205a46", fontSize: "12px", fontWeight: 500 }}>Saving table...</div>
                            </div>
                          </div>
                        )}
                        <TemplateTableGenerator
                          isDisclosureTable={true}
                          forceOpen={true}
                          allowAddRow={true}
                          value={{
                            tableRow: [
                              { name: "", lineType: "" },
                              { name: "", lineType: "" },
                              { name: "", lineType: "" }
                            ]
                          }}
                          onChange={async (next) => {
                            if (isSavingTable) return;
                            const catToUse = "cashflowWorkings";
                            let activeGroupId = subMenuId || fsNotesResponseData?.[0]?._id;

                            if (!activeGroupId) {
                              const tempRes = await getPopulateFSDetailsApiHandler({ projectID: project_id, category: "cashflowWorkings" });
                              if (tempRes?.data?.success && tempRes?.data?.data?.length > 0) {
                                activeGroupId = tempRes.data.data[0]._id;
                              }
                            }

                            if (!activeGroupId) {
                              swal("Error", "No group ID found. Please try refreshing the page.", "error");
                              setIsAddingTable(false);
                              return;
                            }

                            try {
                              setIsSavingTable(true);
                              const params = {
                                projectID: project_id,
                                category: catToUse,
                                groupID: activeGroupId,
                              };

                              const tableColumn = (next.tableColumn || []).map((col) => ({
                                name: col.name || "",
                              }));

                              const finalColumns = tableColumn.length > 0
                                ? tableColumn
                                : [
                                    { name: "Particulars" },
                                    { name: "Current Year" },
                                    { name: "Previous Year" },
                                  ];

                              const payload = {
                                dataType: "table",
                                tableTitle: next.tableTitle || "New Table",
                                tableType: "default",
                                tableColumn: finalColumns,
                              };

                              const response = await addNotesSubgroupApiHandler(params, payload);
                              if (response?.data?.success) {
                                const newSubgroup = response.data.data;
                                
                                // If user has added data to cells, save it
                                const tableDataToSave = next.tableData || next.table || [];
                                if (tableDataToSave.length > 0) {
                                  const cleanRows = tableDataToSave.map(({ isNewRow, ...rest }) => rest);
                                  const updateParams = { ...params, subgroupID: newSubgroup._id || newSubgroup.id };
                                  const updatePayload = { table: cleanRows };
                                  const useReplaceApi = ["general notes", "disclosure", "cashflowWorkings"].includes(catToUse);
                                  if (useReplaceApi) {
                                    await replaceNotesTableApiHandler(updateParams, updatePayload);
                                  } else {
                                    await updatePopulateFSApiHandler(updateParams, updatePayload);
                                  }
                                }
                                
                                await getPopulateFSNotes(catToUse);
                                setIsAddingTable(false);
                                swal({
                                  title: "Success",
                                  text: "Table added successfully. Click on cells to edit.",
                                  icon: "success",
                                  button: "OK",
                                  timer: 2000
                                });
                              } else {
                                swal("Error", response?.data?.message || "Failed to save table", "error");
                              }
                            } catch (err) {
                              console.error("Error adding table:", err?.response || err);
                              const errorMsg = err?.response?.data?.message || "Failed to add table. Please try again.";
                              swal("Error", errorMsg, "error");
                            } finally {
                              setIsSavingTable(false);
                            }
                          }}
                          onCancel={() => {
                            if (!isSavingTable) setIsAddingTable(false);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
            <>
              {!isNotes && activeCat !== "checklist" && (
                <div className={activeCat === "socie" ? "socie-table-wrapper" : ""}>
                  <ShowDetails />
                </div>
              )}
            </>
          )}
              {isNotes && notesData && activeCat !== "checklist"  && (
                <>
                  {renderSubGroups(notesData)}
                </>
              )}

              {isNotes && subMenuId && activeCat === "checklist" && (
                <ShowChecklist subMenuId={subMenuId} />
              )}
              
              {(
                ["BS notes", "PL notes", "general notes", "disclosure"].includes(activeCat)
              ) && (
                <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
                  <DragDropContext onDragEnd={onDragEndItems}>
                    <Droppable droppableId="standalone-bottom-items">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{ display: "grid", gap: 20 }}
                        >
                          {bottomBlocks.map((it, idx) => (
                            <Draggable key={it.id} draggableId={it.id} index={idx}>
                              {(dragProvided) => (
                                <div
                                  ref={dragProvided.innerRef}
                                  {...dragProvided.draggableProps}
                                  style={{
                                    ...dragProvided.draggableProps.style,
                                    width: "100%",
                                  }}
                                >
                                  {it.type === "text" ? (
                                    <QuillReactEditor
                                      value={it.text?.[0]?.content ?? " "}
                                      onChange={(content) => {
                                        updateEditorContent(it.id, content);
                                      }}
                                      dragHandleProps={dragProvided.dragHandleProps}
                                      rightControl={null}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        border: "1px solid #e3efe7",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        background: "#fff",
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          background: "#f8f9f9",
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "10px 12px",
                                          borderBottom: "1px solid #e3efe7",
                                          gap: "12px",
                                        }}
                                      >
                                        <div {...dragProvided.dragHandleProps} style={{ display: "flex", alignItems: "center" }}>
                                          <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                                        </div>
                                        <span
                                          style={{
                                            fontWeight: 600,
                                            fontSize: "13px",
                                            color: "#205a46",
                                            textTransform: "uppercase",
                                            flex: 1,
                                          }}
                                        >
                                          {it.tableTitle || "Table"}
                                        </span>

                                      </div>

                                      <div
                                        style={{
                                          background: "#fff",
                                          padding: 0,
                                        }}
                                      >
                                        <TemplateTableGenerator
                                          isDisclosureTable={true}
                                          tableId={it.id}
                                          forceOpen={it.isTemp ? it.forceOpen : it.id === forceOpenTableId}
                                          value={{
                                            tableTitle: it.tableTitle,
                                            tableRow: it.tableRow,
                                            tableColumn: it.tableColumn,
                                            tableType: it.tableType,
                                            table: getStandaloneTableRowsForSave(it.table),
                                            hasCellData: it.hasCellData,
                                          }}
                                          onChange={(next) => {
                                            const previousRows = it.tableData || it.table || [];
                                            const nextRows = next.tableData || [];
                                            if (
                                              nextRows.length > previousRows.length &&
                                              isStandaloneBlankRow(nextRows[nextRows.length - 1])
                                            ) {
                                              skipStandaloneTableSaveOnceRef.current[it.id] = true;
                                            }
                                            updateTableItem(it.id, {
                                              tableTitle: next.tableTitle,
                                              tableRow: next.tableRow || it.tableRow,
                                              tableColumn: next.tableColumn,
                                              hasCellData: next.hasCellData,
                                              tableData: next.tableData,
                                              tableType: next.tableType,
                                            });
                                          }}
                                          onAfterOpen={() => {
                                            if (it.isTemp) {
                                              setBottomBlocks((prev) =>
                                                prev.map((block) =>
                                                  block.id === it.id
                                                    ? { ...block, forceOpen: false }
                                                    : block
                                                )
                                              );
                                            } else if (forceOpenTableId === it.id) {
                                              setForceOpenTableId(null);
                                            }
                                          }}
                                          onCellBlur={() => {
                                            queueStandaloneTableSave(it.id);
                                          }}
                                          onSaveStructure={(next) => {
                                            handleTableBlockChange(it.id, next);
                                          }}
                                          onCancel={() => {
                                            if (it.isTemp) {
                                              removeItem(it.id);
                                            }
                                          }}
                                          hideHeader={true}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>

                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "center",
                      padding: 12,
                      borderRadius: 12,
                      marginTop: 12,
                    }}
                  >
                    <CirclePlus width={37} />
                    <AddEditor width={140} onClick={handleAddParagraph} style={{ cursor: "pointer" }} />
                    <AddTable width={100} onClick={handleAddTableWithoutModal} style={{ cursor: "pointer" }} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <SidePanel
        showLinkPanel={showLinkPanel}
        setShowLinkPanel={setShowLinkPanel}
        activeCellKey={activeCellKey}
        selectedCell={selectedCell}
        type={activeCat === "disclosure" ? "disclosure" : activeCat === "socie" ? "socie" : activeCat}
        groupingTemplateID={project_id}
        dataID={panelDataID}
        disclosureID={subMenuId} 
        isTemplate={false}
        onApply={async () => {
          await refreshStandaloneCategoryData();
        }}
      />
    </>
  );
};

export default StandaloneFinancialStatement;
